export default __webpack_public_path__ + "static/media/AppStore.0b3698ff.png";